import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';

import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { FlaskConical } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface EmptyABTestStateProps {
  onCreateNew: () => void;
}

export function EmptyABTestState({ onCreateNew }: EmptyABTestStateProps) {
  useLanguage();
  const [showHowItWorks, setShowHowItWorks] = useState(false);
  
  return (
    <div className="flex flex-col items-center justify-center h-[80vh] text-center px-4 animate-fade-in">
      <div className="mb-6 p-8 bg-blue-50 rounded-full">
        <FlaskConical className="h-16 w-16 text-blue-500" />
      </div>
      
      <h1 className="text-2xl font-bold mb-3">
        {translateInterfaceText("Teste diferentes versões de suas VSLs e descubra o que converte mais")}</h1>
      
      <p className="text-gray-600 mb-8 max-w-lg">
        {translateInterfaceText("Compare VSLs, distribua o tráfego automaticamente e otimize sua conversão com dados reais")}</p>
      
      <div className="flex flex-col sm:flex-row gap-4">
        <Button 
          size="lg" 
          onClick={onCreateNew}
          className="px-6"
        >
          {translateInterfaceText("Criar Teste A/B")}</Button>
        
        <Button 
          variant="outline" 
          onClick={() => setShowHowItWorks(true)}
          className="px-6"
        >
          {translateInterfaceText("Como funciona?")}</Button>
      </div>
      
      <Dialog open={showHowItWorks} onOpenChange={setShowHowItWorks}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>{translateInterfaceText("Como funcionam os testes A/B")}</DialogTitle>
            <DialogDescription className="pt-4">
              <div className="space-y-4">
                <div className="border-l-4 border-blue-500 pl-4 py-2">
                  <h3 className="font-medium mb-1">{translateInterfaceText("1. Crie um teste")}</h3>
                  <p className="text-sm text-gray-600">
                    {translateInterfaceText("Selecione de 2 a 6 vídeos diferentes para comparar o desempenho em tempo real.")}</p>
                </div>
                
                <div className="border-l-4 border-blue-500 pl-4 py-2">
                  <h3 className="font-medium mb-1">{translateInterfaceText("2. Distribução automática")}</h3>
                  <p className="text-sm text-gray-600">
                    {translateInterfaceText("O sistema distribuirá o tráfego entre os vídeos selecionados, garantindo uma amostra estatística válida.")}</p>
                </div>
                
                <div className="border-l-4 border-blue-500 pl-4 py-2">
                  <h3 className="font-medium mb-1">{translateInterfaceText("3. Análise de métricas")}</h3>
                  <p className="text-sm text-gray-600">
                    {translateInterfaceText("Acompanhe visualizações, engajamento, cliques e outras métricas importantes para cada variante.")}</p>
                </div>
                
                <div className="border-l-4 border-blue-500 pl-4 py-2">
                  <h3 className="font-medium mb-1">{translateInterfaceText("4. Identifique o vencedor")}</h3>
                  <p className="text-sm text-gray-600">
                    {translateInterfaceText("Com base nos dados reais, descubra qual variante tem melhor performance e finalize o teste quando tiver confiança.")}</p>
                </div>
              </div>
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>
    </div>
  );
}
